import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/cxk-bg.png'


const _withScopeId = n => (_pushScopeId("data-v-0cda604a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%","height":"auto"}
}, null, -1))
const _hoisted_3 = { class: "card-con" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "use-tip" }, "使用说明", -1))
const _hoisted_5 = { class: "num-con" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num-tip" }, "已使用次数", -1))
const _hoisted_7 = { class: "cls-con time-con" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "有效期：永久", -1))
const _hoisted_9 = { style: {"padding":"0.8rem"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jl-title" }, "使用记录", -1))
const _hoisted_11 = {
  class: "white-radius",
  style: {"font-size":"0.9rem"}
}
const _hoisted_12 = { class: "btn-con" }
const _hoisted_13 = { class: "qr-con" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "核销码", -1))
const _hoisted_15 = ["src"]
const _hoisted_16 = { style: {"font-size":"0.9rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.use_click && _ctx.use_click(...args)))
        }, [
          _createVNode(_component_van_icon, {
            name: "info-o",
            color: "#A58A00"
          }),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, _toDisplayString(_ctx.card.useNum) + "次", 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, "购卡时间:" + _toDisplayString(_ctx.card.createDate), 1),
          _hoisted_8
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(_component_van_list, {
        loading: _ctx.loading,
        "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
        finished: _ctx.finished,
        "finished-text": _ctx.finishedTxt,
        error: _ctx.error,
        "onUpdate:error": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.error) = $event)),
        "error-text": "加载失败，点击重试",
        onLoad: _ctx.req_items
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", null, "订单编号：" + _toDisplayString(item.writeoffCode), 1),
              _createElementVNode("div", null, "商家名称：" + _toDisplayString(item.storeName), 1),
              _createElementVNode("div", null, "服务名称：" + _toDisplayString(item.serveName), 1),
              _createElementVNode("div", null, "核销次数：" + _toDisplayString(item.writeoffNum), 1),
              _createElementVNode("div", null, "核销时间：" + _toDisplayString(item.createDate), 1)
            ]))
          }), 256))
        ]),
        _: 1
      }, 8, ["loading", "finished", "finished-text", "error", "onLoad"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      position: "bottom",
      overlay: false,
      "lock-scroll": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_van_button, {
            color: "#D8C14F",
            round: "",
            block: "",
            onClick: _withModifiers(_ctx.btn_click, ["stop"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 二维码 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      show: _ctx.showQr,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showQr) = $event)),
      round: "",
      closeable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: _ctx.user.cardQrUrl,
              style: {"width":"60vw","height":"60vw"}
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, "核销编码：" + _toDisplayString(_ctx.user.id), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}